import { Button } from 'primereact/button';
import React from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { selectCurrentEmpid, selectCurrentUserFullName } from '../../../../pages/login/authSlice';
import { proceedRecalculation, recalculationModel, recalculationProps } from '../recalculation-service';
import { useCreateRecalculationMutation } from '../recalculationSlice';

export const AssociateRecalculation = (props: recalculationProps) => {
    const loggedUser = useSelector(selectCurrentUserFullName);
    const loggedEmpNum = useSelector(selectCurrentEmpid);
    const [createRecalculation] = useCreateRecalculationMutation();
    const isGreenStatus = [1, 2, 8].includes(props?.scoreCardWindowStatus?.approval_window_status_id);
    const colorStyle = { color: isGreenStatus ? 'green' : 'red' };

    const recalculation = () => {
        if (proceedRecalculation('agent', props?.scoreCardWindowStatus?.approval_window_status_id)) {
            const assocRecalculation: recalculationModel = {
                scorecardId: props?.scoreCardWindowStatus?.scorecard_id,
                year: props?.inputYear,
                month: props?.inputMonth,
                employeeNumber: props?.agentNumber ? props?.agentNumber?.toString() : '',
                calculationRequestTypeId: 2,
                calculationRequestStatusId: 1,
                requestBy: loggedEmpNum.toString(),
            };

            createRecalculation(assocRecalculation)
                .unwrap()
                .then(() => {
                    toast.success('Saved Successfully');
                })
                .catch((error: any) => {
                    console.error(error);
                    toast.error('Saved Failed');
                });
        } else toast.warning('Agent cannot be recalculated when approval windows are open.!');
    };

    return (
        <div>
            <div className="card-body border-0">
                <div className="row mt-2">
                    <h6 style={{ fontWeight: '600', fontSize: '16px' }}>Scorecard</h6>
                    <h6 className="col-md-3" style={{ fontSize: '24px' }}>
                        {props?.scoreCardWindowStatus?.scorecard_name}
                    </h6>
                    <h6 className="col-md-3" style={colorStyle}>
                        {props?.scoreCardWindowStatus?.approval_window_status_name}
                    </h6>
                </div>
                <div className="row mt-2">
                    <h6 style={{ fontWeight: '600', fontSize: '16px' }}>Requestor</h6>
                    <h6 style={{ fontWeight: '400', fontSize: '16px' }}>
                        {`${loggedUser} ( ${loggedEmpNum} )`}
                    </h6>
                </div>
                <div className="row mt-2">
                    <div className="col-3">
                        <Button
                            disabled={!props?.agentNumber || !props?.scoreCardWindowStatus?.scorecard_name}
                            label="Recalculate"
                            onClick={recalculation}
                            className="btn-primary ps-5 pe-5 float-end mt-3"
                        />
                    </div>
                    <h6 className="float-end mt-4 col-md-3 col-5">{props?.agentName}</h6>
                </div>
            </div>
        </div>
    );
};
